import * as React from 'react';

import { Container } from '../../../../components/Container';
import { Divider } from '../../../../components/Divider';
import { SIZE_28, SIZE_12 } from '../../../../constants/sizes';
import { UIHeading3 } from '@cian/ui-kit';

export const renderTitle = (title: string): React.ReactNode => (
  <Container padding={`${SIZE_28} ${SIZE_28} 0`}>
    <Container padding={`${SIZE_12} 0 ${SIZE_12}`}>
      <UIHeading3>{title}</UIHeading3>
    </Container>
    <Divider />
  </Container>
);
